export interface WrappedError<T = unknown> {
  originalError?: T;
}

export const isWrappedError = (v: any): v is WrappedError => v.originalError !== undefined;
